import React, { useMemo } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { useTheme } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import styles from '../../../../styles'
import { WHITE } from '../../../../theme'
import { formatJourSemaine } from '../../../../utils/formatDate'
import SvgCheckOk from '../../visites/components/CheckOK'

const useStyles = makeStyles(
	(theme) => ({
		popInContainerStyle: {
			padding: '31px 29px 38px 54px',
			position: 'relative'
		},
		iconStyle: {
			maxWidth: 'fit-content',
			position: 'absolute',
			top: 0,
			right: 29,

			'& svg': {
				'&:hover': {
					background: theme.palette.blue['90']
				},
				padding: 12,
				borderRadius: '100%',
				color: WHITE,
				backgroundColor: theme.palette.blue.main,
				cursor: 'pointer'
			}
		},
		pictoContainer: {
			width: 115,
			maxWidth: 115,
			marginRight: 80
		},
		titre: {
			...styles(theme).title0,
			fontSize: 35,
			lineHeight: '45px',
			marginTop: 35,
			marginBottom: 37
		},
		date: {
			...styles(theme).text0,
			fontSize: 23,
			lineHeight: '33px',
			marginBottom: 25,
		},
		texte: {
			...styles(theme).text1,
			fontSize: 16,
			lineHeight: '23px',
			marginBottom: 27
		},
		boutonVisite: {
			marginRight: 15
		},
		boutonAccueil: {
			backgroundColor: `${theme.palette.blue['5']} !important`,
			color: `${theme.palette.blue.main} !important`
		}
	})
)

interface AcceptingProps {
	date: string
	isEdle: boolean
}

const EDLConfirmationModal: React.FC<AcceptingProps> = (
	{
		isEdle = true,
		date
	}
) => {
	const classes = useStyles()
	const theme = useTheme()
	const intl = useIntl()
	const dateFormatee = useMemo(() => formatJourSemaine(date, intl.locale), [date, intl.locale])

	return (
		<Grid container className={classes.popInContainerStyle}>
			<Grid container item xs className={classes.iconStyle}>
				<CloseIcon onClick={() => window.location.reload()} />
			</Grid>

			<Grid
				container
				item
				xs
				className={classes.pictoContainer}
			>
				<SvgCheckOk color={theme.palette.primary.main} />
			</Grid>

			<Grid
				container
				item
				xs
			>
				{/* Titre de la popin */}
				<Grid container item xs={12} className={classes.titre}>
					<FormattedMessage
						id={`preparezArrivee.modalPriseRdvEdle.${isEdle ? 'edleValide' : 'edlsValide'}`}
						defaultMessage="Votre rendez-vous pour l'état des lieux d'entrée a bien été confirmé"
						description="Titre de la popin de confirmation de RDV"
					/>
				</Grid>

				{/* Résumé de la date de rdv */}
				<Grid container item xs={12} className={classes.date}>
					{dateFormatee}
				</Grid>
			</Grid>
		</Grid>
	)
}

export default EDLConfirmationModal
